import React, {Component} from 'react'
import AuthenticationService from "../../Services/AuthenticationService";
import './ManageTinsForUser.css'
import Button from '@material-ui/core/Button';
import ViewTinsForUserTable from '../ViewTinsForUserTable'
import Grid from "@material-ui/core/Grid";

window.analytics ={pageName:'Manage Users: Manage TINs'};
class ViewTinsForUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            response: [], ftins: [], ftinsFiltered: [], selected: [], errorMsg: ''
        }
    }
    componentDidMount() {
        this.loadList();      
    }

    loadList = () => {
       const selected = [];
        console.log( `Mange users get tins for user................`)
        AuthenticationService.getFtinsForManageUserId( this.props.location.state.user.id)
            .then((response) => {
                if (response.status === 200) {
                  
                    response.data.forEach( tin => {
                        if(tin.hasIt === true) {
                             selected.push({ ftin: tin.ftin })
                        }
                    })
                    if(selected.length > 0) {
                        this.setState({ftins: selected, ftinsFiltered: selected});
                    }
                } else {
                    this.setState({errorMsg: `Error: There was an error retrieving data. Please try again or contact Customer Service.`})
                }
            }).catch(function (error) {
            console.log('Manage Ftins for User Error:' + error);
        })
    }

    setfilter = (filtered) => {
        console.log( `in fitler set state`)
        if(filtered && filtered.length >= 0)
            this.setState({ftinsFiltered:filtered})
    }
 

    handleCancel = () => {  
        this.props.history.push({
            pathname: '/wcpp/UserSearch',
            state: {searchInfo: this.props.location.state.searchInfo}
        })

    }


    render() {

        return(
                <div className='App-content ManageTinsForUser'>
                    <h1 className='App-page-label'>
                        {`User Search: View TINs for ${this.props.location.state.user.userFirstName} ${this.props.location.state.user.userLastName}`}</h1>
                    <div className='App-error App-font' hidden={this.state.errorMsg === ''}>{this.state.errorMsg}</div>
                 
                    <ViewTinsForUserTable tinsFiltered={this.state.ftinsFiltered} setFilter={this.setfilter}  tins={this.state.ftins} 
                                             />
                    <Grid>    
                        <Button variant="outlined"  onClick={this.handleCancel}>
                           BACK
                        </Button>
                    </Grid>

                </div>
           
        );

    }
}
export default ViewTinsForUser;